import { createApp } from 'vue'
// import VueCompositionAPI from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Spin, message } from 'ant-design-vue';

import '@/style/common.scss'
import "@/assets/fonts/font.scss"

const app = createApp(App)
app.config.productionTip = false;

app.use(Spin);
app.config.globalProperties.$message = message;

// app.use(VueCompositionAPI);
app.use(store).use(router).mount('#app')
